import { Paper, Typography, Box } from '@mui/material';

const CustomTooltipResumen = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const data = payload[0]?.payload;

        return (
            <Paper
                elevation={3}
                sx={{
                    padding: 1.5,
                    maxWidth: 260,
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                }}
            >
                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                    {data?.nombre}
                </Typography>
                <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}
                >
                    <Typography variant="body2" sx={{ color: '#0D47A1' }}>
                        Clientes Asignados: {data?.clientesAsignados || 0}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#1976D2' }}>
                        Envíos Totales: {data?.preventas}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#64B5F6' }}>
                        Ventas Efectivas: {data?.ventasEfectivas}
                    </Typography>
                </Box>
            </Paper>
        );
    }
    return null;
};

export default CustomTooltipResumen;
